import { useEffect } from 'react';

/**
 * Close a modal when the user presses Escape.
 *
 *   useEscapeClose(showModal, () => setShowModal(false));
 *
 * No-op when `isOpen` is falsy, so it's safe to call unconditionally at the
 * top level of the component. Only attaches one document-level keydown listener
 * while the modal is open.
 */
export default function useEscapeClose(isOpen, onClose) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);
}
